import type { IconProps } from '../types/IconProps.ts';
export const CopyCheck: IconProps = {
    name: 'CopyCheck',
    children: [
        `<path d="M4 16a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2" />`,
        `<path d="M20 8H10a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2" />`,
        `<path d="m12 15.12 1.98 1.98q.14.12.28 0L18 13" />`,
    ]
};